/* eslint-disable @typescript-eslint/no-explicit-any */
export class ErrorsMessage {
  type: string = "";
  message: string = "";
  title: string = "";
  params: any;
}
